var React = require('react');

function FrontendInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.3173 15.5167L4.80065 9L11.3173 2.48333L9.33398 0.5L0.833984 9L9.33398 17.5L11.3173 15.5167ZM18.684 15.5167L25.2007 9L18.684 2.48333L20.6673 0.5L29.1673 9L20.6673 17.5L18.684 15.5167Z","fill":"#2E7D32"}));
}

FrontendInline.defaultProps = {"width":"30","height":"18","viewBox":"0 0 30 18","fill":"none"};

module.exports = FrontendInline;

FrontendInline.default = FrontendInline;
